import React from "react";

import AirbyteApi from "apis/airbyte";
import { Typography, Toastr, Alert } from "clearsense-ui/components";
import { useAirbyteState } from "contexts/airbyte";

const DeleteAlert = ({
  isDeleteAlertOpen,
  setIsDeleteAlertOpen,
  connectionId,
  handlePaneClose,
  fetchConnections,
}) => {
  const { workspaceId } = useAirbyteState();

  const handleDelete = async () => {
    try {
      await AirbyteApi.deleteConnection({ connectionId });
      Toastr.success("Connection deleted successfully");
    } catch (error) {
      logger.error(error);
    } finally {
      handlePaneClose();
      fetchConnections(workspaceId);
    }
  };

  return (
    <Alert
      isOpen={isDeleteAlertOpen}
      onClose={() => setIsDeleteAlertOpen(false)}
      submitButtonLabel="Delete"
      onSubmit={handleDelete}
      title="Confirm connection deletion"
      message={
        <>
          <Typography>
            This can not be un-done without a full re-sync. Note that:
          </Typography>
          <Typography>
            - All past logs and configurations will be deleted
          </Typography>
          <Typography>- Updates of new data will stop</Typography>
          <Typography>
            - No existing data in the destination will be altered
          </Typography>
        </>
      }
    />
  );
};

export default DeleteAlert;
